import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";

import { type ICheckEmailBody, type ICheckEmailResponse } from "@types";

export const authenticationApiReducerKey = "authenticationApi";
export const authenticationApi = createApi({
  reducerPath: authenticationApiReducerKey,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl() }),
  endpoints: (builder) => ({
    postCheckEmail: builder.mutation<ICheckEmailResponse, ICheckEmailBody>({
      query: (body) => ({
        url: "/authentication/check-email",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { usePostCheckEmailMutation } = authenticationApi;
